import {createContext} from "react";

const MapContext=createContext({
    midblockFilter:false,
    intersectionFilter:false,

});

export default MapContext;


